import colors from '@/styles/colors'
import { Button, styled } from '@mui/material'

export const RoundedFilledButton = styled(Button)(({ theme }) => ({
  backgroundColor: 'rgba(255, 255, 255, 0.08)',
  backdropFilter: 'blur(10px)',
  border: '1px solid rgba(255, 255, 255, 0.12)',
  color: 'white',
  fontSize: 14,
  fontWeight: '600',
  letterSpacing: '-0.01em',
  borderRadius: 12,
  alignItems: 'center',
  padding: '10px 20px',
  height: 44,
  textTransform: 'none',
  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
  transition: 'background-color 0.2s, border-color 0.2s, transform 0.2s, box-shadow 0.2s',
  '& .MuiButton-startIcon': {
    marginRight: '8px',
    '& svg': {
      width: 18,
      height: 18,
    },
  },
  '&:hover': {
    backgroundColor: 'rgba(99, 102, 241, 0.2)',
    borderColor: 'rgba(99, 102, 241, 0.4)',
    transform: 'translateY(-2px)',
    boxShadow: '0 4px 16px rgba(99, 102, 241, 0.25)',
  },
  '&:active': {
    transform: 'translateY(0) scale(0.95)',
    backgroundColor: 'rgba(99, 102, 241, 0.3)',
  },
  '&:disabled': {
    color: 'rgba(255, 255, 255, 0.4)',
    backgroundColor: 'rgba(255, 255, 255, 0.05)',
    borderColor: 'rgba(255, 255, 255, 0.08)',
  },

  '&.Mui-focusVisible': {
    boxShadow: 'none', // Remove the glow
    outline: 'none',   // Remove the blue browser line
    backgroundColor: 'rgba(255, 255, 255, 0.08)', // Keep original background (don't flash)
  },
  '&:focus': {
    outline: 'none',
  }
}))

export const RoundedActionButton = styled(Button)(({ theme, variant }) => ({
  backgroundColor: theme.palette.brand.light,
  color: 'white',
  fontSize: 13,
  fontWeight: '600',
  borderRadius: 50,
  alignItems: 'center',
  padding: '8px 16px',
  '&:hover': {
    backgroundColor: theme.palette.brand.light,
  },

  ...(variant === 'contained' && {
    backgroundColor: theme.palette.brand.light,
    color: 'white',
    borderColor: theme.palette.brand.light,
    border: `1px solid ${theme.palette.brand.light}`,
  }),
  ...(variant === 'outlined' && {
    backgroundColor: 'transparent',
    color: theme.palette.brand.light,
    borderColor: theme.palette.brand.light,
    border: `1px solid ${theme.palette.brand.light}`,
    '&:hover': {
      borderColor: 'transparent',
      backgroundColor: theme.palette.brand.light,
      color: 'white',
    },
  }),
  '&:disabled': {
    color: 'white',
    backgroundColor: 'lightGray',
    borderColor: 'transparent',
  },
}))

export const RoundedOutlineButton = styled(Button)(({ theme }) => ({
  backgroundColor: 'transparent',
  color: theme.palette.brand.light,
  borderColor: theme.palette.brand.light,
  border: `1px solid ${theme.palette.brand.light}`,
  fontSize: 13,
  fontWeight: '600',
  borderRadius: 50,
  alignItems: 'center',
  padding: '10px 40px',
  '&[aria-selected = true]': {
    border: `1px solid ${colors.themePink}`,
    backgroundColor: colors.themePinkLight,
    color: colors.themePink,
  },
}))
